<template>
    <div class="container gap-3 mt-4">
        <!-- Кнопки -->
        <button class="btn btn-primary mt-2" @click="showModal('addExcelFile')">
            СНП
        </button>
        <button
            class="btn btn-primary mt-2"
            @click="showModal('addExcelFile2')"
        >
            Загрузить файл "Мониторинг СНП"
        </button>
        <button class="btn btn-primary mt-2" @click="showModal('addParams')">
            Загрузить показатели СНП
        </button>
        <button class="btn btn-primary mt-2" @click="showModal('addParams2')">
            Загрузить ФЛК показателей СНП
        </button>
        <button
            class="btn btn-primary mt-2"
            @click="showModal('updateSnpData')"
        >
            Загрузить данные по СНП
        </button>
        <button class="btn btn-primary mt-2" @click="showModal('updateDict')">
            Обновить КАТО для СНП
        </button>

        <!-- Модальные окна -->
        <Modal
            v-if="activeModal === 'addExcelFile'"
            title="Загрузить excel файл"
            @close="hideModal"
        >
            <div class="input-group mb-3">
                <div class="input-group-prepend" style="height: 34px">
                    <label class="input-group-text">Форма ввода</label>
                </div>
                <v-select
                    style="flex: 1 1 0%"
                    v-if="inputForms.length"
                    label="name"
                    :options="inputForms"
                    placeholder="Выберите значение"
                    v-model="snp.inputForm"
                />
            </div>
            <input type="file" class="form-control" @change="syncFile" />
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="save">Сохранить</button>
            </template>
        </Modal>

        <Modal
            v-if="activeModal === 'addExcelFile2'"
            title="Загрузить excel файл Мониторинг СНП"
            @close="hideModal"
        >
            <input type="file" class="form-control" @change="syncFile2" />
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="save2">
                    Сохранить
                </button>
            </template>
        </Modal>

        <Modal
            v-if="activeModal === 'addParams'"
            title="Загрузить excel файл показатели СНП"
            @close="hideModal"
        >
            <input type="file" class="form-control" @change="syncParamsFile" />
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="saveParamsFile">
                    Сохранить
                </button>
            </template>
        </Modal>

        <Modal
            v-if="activeModal === 'addParams2'"
            title="Загрузить excel файл ФЛК показателей СНП"
            @close="hideModal"
        >
            <input type="file" class="form-control" @change="syncParams2File" />
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="saveParams2File">
                    Сохранить
                </button>
            </template>
        </Modal>

        <Modal
            v-if="activeModal === 'updateSnpData'"
            title="Загрузить excel файлы данные по СНП"
            @close="hideModal"
        >
            <input
                type="file"
                class="form-control"
                accept=".xls,.xlsx"
                multiple
                @change="syncUpdateSnpDataFiles"
            />
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="saveUpdateSnpDataFiles">
                    Сохранить
                </button>
            </template>
        </Modal>

        <Modal
            v-if="activeModal === 'updateDict'"
            title="Вы действительно хотите обновить справочник?"
            @close="hideModal"
        >
            <template #footer>
                <button class="btn btn-secondary" @click="hideModal">
                    Закрыть
                </button>
                <button class="btn btn-primary" @click="updateDictHandle">
                    Да
                </button>
            </template>
        </Modal>
    </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "SnpUpload",
    components: {
        "v-select": vSelect,
        Modal: {
            functional: false,
            props: ["title"],
            render(h) {
                return h(
                    "div",
                    {
                        class: "modal fade show d-block",
                        style: { background: "rgba(0,0,0,0.5)" },
                        on: {
                            click: (e) =>
                                e.target === e.currentTarget &&
                                this.$emit("close"),
                        },
                    },
                    [
                        h(
                            "div",
                            {
                                class: "modal-dialog",
                                attrs: { role: "document" },
                            },
                            [
                                h("div", { class: "modal-content" }, [
                                    h("div", { class: "modal-header" }, [
                                        h(
                                            "h5",
                                            { class: "modal-title" },
                                            this.title
                                        ),
                                        h(
                                            "button",
                                            {
                                                class: "close",
                                                attrs: { type: "button" },
                                                on: {
                                                    click: () =>
                                                        this.$emit("close"),
                                                },
                                            },
                                            [h("span", "×")]
                                        ),
                                    ]),
                                    h(
                                        "div",
                                        { class: "modal-body" },
                                        this.$slots.default
                                    ),
                                    h(
                                        "div",
                                        { class: "modal-footer" },
                                        this.$slots.footer
                                    ),
                                ]),
                            ]
                        ),
                    ]
                );
            },
        },
    },
    data() {
        return {
            inputForms: [],
            snp: { inputForm: null, file: null },
            monitoringSnp: { file: null },
            params: { file: null },
            params2: { file: null },
            updateSnpData: { files: [] },
            secretKey:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXZlbG9wZXIiOiJTYWdhc2ggQXJneW4ifQ.4ejj9_Ce45z0AEUyFrpZS2QjIvVV96899UTyLM8Icro",
            activeModal: null,
        };
    },
    methods: {
        showModal(id) {
            this.activeModal = id;
            document.body.classList.add("modal-open");
        },
        hideModal() {
            this.activeModal = null;
            document.body.classList.remove("modal-open");
        },
        async loadInputForms() {
            const res = await fetch("/api/input-forms");
            this.inputForms = await res.json();
        },
        syncFile(e) {
            this.snp.file = e.target.files[0];
        },
        syncFile2(e) {
            this.monitoringSnp.file = e.target.files[0];
        },
        syncParamsFile(e) {
            this.params.file = e.target.files[0];
        },
        syncParams2File(e) {
            this.params2.file = e.target.files[0];
        },
        syncUpdateSnpDataFiles(e) {
            this.updateSnpData.files = Array.from(e.target.files);
        },
        async save() {
            const data = new FormData();
            data.append("file", this.snp.file);
            const res = await fetch(
                `/api/snp/file?input_form_id=${this.snp.inputForm.id}`,
                { method: "POST", body: data }
            );
            if (res.ok) {
                this.hideModal();
                fetch("/api/snp/reload-widget");
            } else alert("Ошибка загрузки");
        },
        async save2() {
            const data = new FormData();
            data.append("file", this.monitoringSnp.file);
            const res = await fetch("/api/snp/monitoring-file", {
                method: "POST",
                body: data,
            });
            if (res.ok) this.hideModal();
            else alert("Ошибка загрузки");
        },
        async saveParamsFile() {
            const data = new FormData();
            data.append("file", this.params.file);
            const res = await fetch("/snp/api/v1/report/upload-header", {
                method: "POST",
                headers: {
                    "secret-key": this.secretKey,
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
                body: data,
            });
            if (res.ok) {
                this.hideModal();
                this.makeToast(
                    "success",
                    "Результат сохранения",
                    "Успешно выполнено"
                );
                fetch("/api/snp/reload-widget");
            } else {
                this.hideModal();
                this.makeToast(
                    "danger",
                    "Результат сохранения",
                    "Произошла ошибка, попробуйте позже"
                );
            }
        },
        async saveParams2File() {
            const data = new FormData();
            data.append("file", this.params2.file);
            const res = await fetch("/snp/api/v1/report/upload-control", {
                method: "POST",
                headers: {
                    "secret-key": this.secretKey,
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
                body: data,
            });
            if (res.ok) {
                this.hideModal();
                this.makeToast(
                    "success",
                    "Результат сохранения",
                    "Успешно выполнено"
                );
                fetch("/api/snp/reload-widget");
            } else {
                this.hideModal();
                this.makeToast(
                    "danger",
                    "Результат сохранения",
                    "Произошла ошибка, попробуйте позже"
                );
            }
        },
        async saveUpdateSnpDataFiles() {
            for (const file of this.updateSnpData.files) {
                if (file.size > 100 * 1024 * 1024) {
                    alert(`Файл ${file.name} превышает 100 МБ!`);
                    return;
                }
            }

            const data = new FormData();
            this.updateSnpData.files.forEach((file) => {
                data.append("file", file);
            });

            try {
                const res = await fetch("/snp/api/v1/report", {
                    method: "POST",
                    headers: {
                        "secret-key": this.secretKey,
                        Authorization: `Bearer ${this.$store.getters.token}`,
                    },
                    body: data,
                });

                if (res.ok) {
                    this.hideModal();
                    this.makeToast(
                        "success",
                        "Результат сохранения",
                        "Успешно выполнено"
                    );
                } else {
                    this.hideModal();
                    this.makeToast(
                        "danger",
                        "Результат сохранения",
                        "Произошла ошибка, попробуйте позже"
                    );
                }
            } catch (error) {
                this.hideModal();
                this.makeToast(
                    "danger",
                    "Результат сохранения",
                    "Произошла ошибка, попробуйте позже"
                );
                console.error(error);
            }
        },

        async updateDictHandle() {
            const res = await fetch("/snp/api/v1/kato/update", {
                method: "POST",
                headers: {
                    "secret-key": this.secretKey,
                    Authorization: `Bearer ${this.$store.getters.token}`,
                },
            });
            if (res.ok) {
                this.hideModal();
                this.makeToast(
                    "success",
                    "Результат сохранения",
                    "Успешно выполнено"
                );
                fetch("/api/snp/reload-widget");
            } else {
                this.hideModal();
                this.makeToast(
                    "danger",
                    "Результат сохранения",
                    "Произошла ошибка, попробуйте позже"
                );
            }
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: "b-toaster-top-center",
                autoHideDelay: 5000,
                appendToast: true,
            });
        },
    },
    mounted() {
        this.loadInputForms();
    },
};
</script>

<style>
.modal-open {
    overflow: hidden;
}
</style>
